import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { A, H3, H5, P } from '@upsolve/ui';

import upsolveStats from '../../../content/onBuild/upsolveStats.json';
import { withAmp } from '../AMP/AmpContext';
import BlobLedge from '../../../static/images/blob-ledge.svg';
import BlobAttorney from '../../../static/images/blob-attorney.svg';
import FinancialJourneyScape from '../../../static/images/financial-journey-scape.svg';
import Button from '../Inputs/Button.span';

const CTASideBySide = styled.div`
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
  div.side-by-side__header {
    width: 100%;
    padding: 1.5em 1em 1em;
    text-align: center;
    h3, h5 {
      color: ${props => props.theme.colors.brand[500]};
    }
  }
  div.side-by-side__options {
    display: flex;
    padding: 0.5em 1.5em 1.5em;
    @media(max-width: ${props => props.theme.breakpoints[500]}) {
      flex-direction: column;
    }
  }
  div.side-by-side__option {
    width: 50%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.colors.white[900]};
    border-radius: 1em;
    margin: 2em;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0,0,25,0.1);
    h3, h5, p, a {
      color: ${props => props.theme.colors.brand[500]};
    }
    p {
      padding: 0 1.5em;
      a {
        text-decoration: underline;
      }
    }
    button {
      margin: 0.5em;
    }
    .option__body {
      padding: 1.5em;
    }
    .option__blob {
      svg {
        height: 200px;
        max-height: 200px;
        width: auto;
        fill: ${props => props.theme.colors.brand[500]};
        padding: 0.5em;
      }
      &.attorney {
        svg {
          padding-bottom: 1.5em;
          fill: ${props => props.theme.colors.brand[500]};
        }
      }
    }
    .option__count {
      background: ${props => props.theme.colors.white[700]};
      color: ${props => props.theme.colors.brand[500]};
      width: 100%;
      padding: 1em 0;
      font-size: 0.8em;
      font-weight: 500;
      text-decoration: underline;
    }
    @media(max-width: ${props => props.theme.breakpoints[500]}) {
      width: 100%;
      margin: 0;
      button {
        width: 100%;
      }
    }
  }
  div.side-by-side__divider {
    width: 1px;
    background: ${props => props.theme.colors.white[300]};
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      border-radius: 24px;
      background: ${props => props.theme.colors.brand[500]};
      color: ${props => props.theme.colors.white[900]};
    }
    @media(max-width: ${props => props.theme.breakpoints[500]}) {
      justify-content: center;
      height: 1px;
      width: 100%;
      margin-top: 1.5em;
      margin-bottom: 1.5em;
    }
  }

  .landscape {
    padding: 0 1em 1em;
    text-align: center;
    svg {
      height: 240px;
      opacity: 0.25;
    }
    @media(max-width: ${props => props.theme.breakpoints[500]}) {
      svg {
        max-width: 100%;
        height: 100px;
      }
    }
  }
`;

const CTASideBySideOfferings = () => (
  <CTASideBySide data-test-id="ctaSideBySideOfferings">
    <div className="side-by-side__header">
      <H3>It's easy to get help</H3>
      <H5>Choose one of the options below to get assistance with your bankruptcy:</H5>
    </div>
    <div className="side-by-side__options">
      <div className="side-by-side__option">
        <div className="option__body">
          <div className="option__blob ledge">
            <BlobLedge />
          </div>
          <H3>Free Bankruptcy Help</H3>
          <P>Take our <a href="https://my.upsolve.org/screener">bankruptcy screener</a> to see if you're a fit for Upsolve's free service!</P>
          <a href="https://my.upsolve.org/screener">
            <Button size="md">
              Learn More
            </Button>
          </a>
        </div>
        <div className="option__count ledge">
        <b>☆ {upsolveStats.familiesHelped.total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} families</b> filed with Upsolve ☆
        </div>
      </div>
      <div className="side-by-side__divider">
        <span>OR</span>
      </div>
      <div className="side-by-side__option">
        <div className="option__body">
          <div className="option__blob attorney">
            <BlobAttorney />
          </div>
          <H3>Private Attorney</H3>
          <P>Get a free bankruptcy evaluation from a local law firm.</P>
          <a href="https://upsolve.org/find-a-lawyer">
            <Button size="md">
              Learn More
            </Button>
          </a>
        </div>
      </div>
    </div>
    <P textAlign="center"><b>Want to talk to a counselor at a nonprofit we trust about alternatives to bankruptcy? It’s free.</b> <A href="https://upsolve.org/find-a-credit-counselor">Get More Info</A></P>
    <div className="landscape">
      <FinancialJourneyScape />
    </div>
  </CTASideBySide>
);

export default withAmp(CTASideBySideOfferings);
